import { Button, MenuItem, Typography } from '@mui/material'
import DropDownButton from 'components/DropDownButton';
import SelectInput from 'components/form/input/SelectInput'
import TextInput from 'components/form/input/TextInput'
import { inscricoesCSV } from 'entity/Rodada/functions';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import { colorAusente, colorInscrito, colorPendenteInscricao, colorPresente, colorSaiu } from '../../FunctionsPainel';
import { includesInsensitive } from 'util/string';
import DataTable from 'components/DataTable';
import AcoesIncricao from '../AcoesIncricao';
import _ from 'lodash'
import EtiquetasInscricaoReport from 'entity/Inscricao/Relatorios/EtiquetasInscricaoReport';
import { useFieldValue } from 'components/form/input/NestedField';

import AgendasParticipantes from 'entity/Inscricao/Relatorios/AgendasParticipantes';
import { usePainelContext } from '../../PainelContext';

export default function PainelInscritosAncoras({ rodada }) {
    console.log('PainelInscritosAncoras')
    const { inscricoes, reunioes } = usePainelContext();
    let ancoras = (inscricoes || []).filter(f => {
        return f.tipo === "ÂNCORA";
    })


    const [txtFiltroParticipante] = useFieldValue("txtFiltroAncora")
    const [statusEventoFiltroParticipante] = useFieldValue("statusEventoFiltroAncora")
    const navigate = useNavigate();

    const imprimirCrachas = (participantes) => {

        new EtiquetasInscricaoReport({ lista: participantes }).generate();
    }



    let filteredParticipantes = ancoras.filter(f => {
        if (!f.empresa) {
            return false
        }

        if (statusEventoFiltroParticipante) {
            if (statusEventoFiltroParticipante === "CANCELADO") {
                if (f.status !== 'CANCELADO') return false
            } else if (statusEventoFiltroParticipante === "PENDENTE/INSCRICAO") {
                if (f.status !== "PENDENTE/INSCRICAO") return false
            } else if (statusEventoFiltroParticipante !== "TODOS") {
                if (f.statusEvento !== statusEventoFiltroParticipante || f.status === 'CANCELADO') return false
            } else if (statusEventoFiltroParticipante === "TODOS") {
                if (f.status === 'CANCELADO') return false
            }
        } else {
            if (f.status === 'CANCELADO') return false
        }
        let b = true;

        if (b && txtFiltroParticipante) {
            b = false;
            if (includesInsensitive(f.empresa.nomeFantasia, txtFiltroParticipante)) b = true
            if (includesInsensitive(f.empresa.funcionarios.nomeParticipante, txtFiltroParticipante)) b = true
            if (includesInsensitive(f.empresa.razaoSocial, txtFiltroParticipante)) b = true
            if (includesInsensitive(f.empresa.nomeEmpresaCracha, txtFiltroParticipante)) b = true
            if (includesInsensitive(f.empresa.funcionarios.nomeCracha, txtFiltroParticipante)) b = true
        }

        return b
    })


    const imprimirAgendas = () => {

        new AgendasParticipantes({ inscricoes: ancoras, reunioes })
            .generate({
                textoCabecalho1: rodada.nome,// "textoCabecalho1",
                textoCabecalho2: rodada.descricao,// "textoCabecalho2",
            })
    }

    return (<>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: 10, flexWrap: 'wrap' }}>
            <TextInput
                name="txtFiltroAncora"
                label="FILTRO NOME EMPRESA, CRACHÁ EMPRESA, RAZÃO SOCIAL, NOME PARTICIPANTE, CRACHÁ PARTICIPANTE"
                sx={{ flex: 8, }}
            />
            <SelectInput
                sx={{ flex: 1 }}
                name="statusEventoFiltroAncora"
                label="FILTRO STATUS"
                options={[
                    "INSCRITO",
                    "PRESENTE",
                    "SAIU",
                    "AUSENTE",
                    "PENDENTE/INSCRICAO",
                    "CANCELADO",
                    "TODOS",
                ]}
            // defaultValue={"TODOS"}
            />
            <Button
                onClick={() => {
                    navigate(`/inscricao?rodada=${rodada.uid}`)
                }}
            >
                Nova Inscrição
            </Button>
            <DropDownButton label="Relatórios">
                <MenuItem onClick={() => imprimirCrachas(ancoras.filter(p => p.status === "INSCRITO" && p.termo))}>Crachás</MenuItem>
                <MenuItem onClick={() => inscricoesCSV(filteredParticipantes.filter(p => (p.status === "INSCRITO" || p.status === "PENDENTE/INSCRICAO") && p.termo), rodada)}>{"Participantes (.xlsx)"}</MenuItem>
                <MenuItem
                    onClick={() => imprimirAgendas()}
                >
                    Imprimir Agendas
                </MenuItem>
            </DropDownButton>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: 5, flexWrap: 'wrap' }}>
            Legenda
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ height: 25, width: 25, backgroundColor: colorInscrito, margin: 5 }} />
                Inscrito
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ height: 25, width: 25, backgroundColor: colorPresente, margin: 5 }} />
                Presente
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ height: 25, width: 25, backgroundColor: colorSaiu, margin: 5 }} />
                Saiu
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ height: 25, width: 25, backgroundColor: colorAusente, margin: 5 }} />
                Ausente ou Cancelado
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ height: 25, width: 25, backgroundColor: colorPendenteInscricao, margin: 5 }} />
                Pendente/Inscricao
            </div>
        </div>

        {filteredParticipantes.length
            ? <>
                <DataTable
                    getRowClassName={(params) => {
                        if (params.row.status === "PENDENTE/INSCRICAO") {
                            return "RowStatusPendenteInscricao"
                        } else if (params.row.statusEvento === "INSCRITO") {
                            return "RowStatusInscrito"
                        } else if (params.row.statusEvento === "PRESENTE") {
                            return "RowStatusPresente"
                        } else if (params.row.statusEvento === "SAIU") {
                            return "RowStatusSaiu"
                        } else if (params.row.statusEvento === "AUSENTE") {
                            return "RowStatusAusente"
                        }

                        return "RowStatusStatusNaoMapeado"
                    }}
                    columns={[
                        {
                            field: "dataCriacao",
                            headerName: "Data",
                            flex: 0.8,
                            valueGetter: r => {
                                let s1 = r.row.dataFirstChange.split("/")
                                let s2 = r.row.dataFirstChange.split(", ")
                                let data = s1[0] + "/" + s1[1] + " " + s2[1]
                                return data
                            },
                            compare: (v1, v2) => {
                                const [d1, t1] = v1.split(" ");
                                const [d2, t2] = v2.split(" ");
                                const [day1, month1] = d1.split("/").map(Number);
                                const [day2, month2] = d2.split("/").map(Number);
                                const [hour1, min1] = t1.split(":").map(Number);
                                const [hour2, min2] = t2.split(":").map(Number);
                                const date1 = new Date(2000, month1 - 1, day1, hour1, min1);
                                const date2 = new Date(2000, month2 - 1, day2, hour2, min2);
                                return date1 - date2;
                                // return new Date(v1) - new Date(v2);
                            }
                        },
                        {
                            field: "statusEvento", headerName: "STATUS", flex: 0.8,
                            renderCellValue: (row) => {
                                return <Typography>{row.statusEvento === 'AUSENTE' ? "(AUSENTE)" : _.get(row, "statusEvento")}</Typography>
                            }
                        },
                        {
                            field: "empresa.nomeEmpresaCracha", headerName: "NOME EMPRESA", flex: 2,
                            renderCellValue: (row) => {
                                return (
                                    <Typography>
                                        {row.status === "PENDENTE/INSCRICAO"
                                            ? "(PENDENTE/INSCRICAO) - "
                                            : row.statusEvento === 'AUSENTE'
                                                ? "(AUSENTE) - "
                                                : ""
                                        }
                                        {_.get(row, "empresa.nomeEmpresaCracha")}
                                    </Typography>
                                )
                            }
                        },
                        {
                            field: "mesa.name", headerName: "Mesa", flex: 1,
                            // renderCellValue: (row) => {
                            //     return <Typography>{_.get(row, "mesa.index") ? (_.get(row, "mesa.index")) + " - " : ""} {_.get(row, "mesa.name")}</Typography>
                            // }
                        },

                        // nomeCracha não é obrigatório, por isso o renderCellValue
                        {
                            field: "empresa.funcionarios.nomeCracha",
                            headerName: "NOME",
                            flex: 2,
                            renderCellValue: (row) => {
                                return (
                                    <Typography>
                                        {row.empresa.funcionarios.nomeCracha
                                            ? _.get(row, "empresa.funcionarios.nomeCracha")
                                            : _.get(row, "empresa.funcionarios.nomeParticipante")
                                        }
                                    </Typography>
                                )
                            }
                        },
                        { field: "empresa.funcionarios.celular", headerName: "CELULAR", flex: 1 },
                        {
                            field: "dataFirstChange",
                            headerName: "Data da Inscrição",
                            flex: 1,
                            renderCellValue: (row) => {
                                return (
                                    <Typography>
                                        {row.dataFirstChange
                                            ? _.get(row, "dataFirstChange")
                                            : _.get(row, "dataLastChangeStr")
                                        }
                                    </Typography>
                                )
                            }
                        },
                        {
                            field: "index",
                            headerName: "Ações",
                            flex: 1,
                            renderCellValue: (row) => {
                                return <AcoesIncricao inscricao={row} reunioes={reunioes} />
                            },
                        },
                    ]}
                    rows={filteredParticipantes}
                    autoHeight
                    sx={{
                        "& .MuiDataGrid-row:hover": {
                            cursor: "pointer",
                        },
                    }}
                />
            </>
            : <Typography
                sx={{ display: "flex", justifyContent: 'center', color: 'text.disabled' }}
                variant="h6"
            >
                - NENHUM ÂNCORA -
            </Typography>
        }
    </>
    )
}
